'use strict';

import template from './cities.html';

export default {
  template,
  controller($stateParams, seoCS, deslug, slug) {
    'ngInject';

    this.slug = slug;

    this.$onInit = () => {
      this.location = deslug.it($stateParams.name);
      seoCS.getLocalCities(slug.it(this.location)).then((result) => {
        this.data = result.data;
        this.count = result.data.reduce((a, v) => {
          return a + v.count * 1;
        }, 0);
      }).finally(() => {
        this.fetched = true;
      });
    };

  }
};



// WEBPACK FOOTER //
// ./app/src/modules/cities/cities.js